import { render, staticRenderFns } from "./loading-screen.vue?vue&type=template&id=6b69e930&scoped=true"
import script from "./loading-screen.vue?vue&type=script&setup=true&lang=ts"
export * from "./loading-screen.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./loading-screen.vue?vue&type=style&index=0&id=6b69e930&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b69e930",
  null
  
)

export default component.exports